import { useCallback, useEffect } from 'react';

import { supportUserStatus } from '@/features/dashboard-users/store/support-user.model';
import { useAppDispatch, useAppSelector } from '@/hooks/redux-helpers';
import { selectAndSortDashoardUsers } from '@/store/selectors';
import { getSupportUsers } from '@/features/dashboard-users/store/support-user.actions';

export function useActiveDashboardUsers() {
  const dispatch = useAppDispatch();
  const activeDashboardUsers = useAppSelector(selectAndSortDashoardUsers);

  const activeDashboardUsersCursor = useAppSelector((state) => state.supportUser.dashboardUsers.cursor);
  const isActiveDashboardUsersLoading = useAppSelector((state) => state.supportUser.search.isLoading);

  useEffect(() => {
    dispatch(getSupportUsers({ status: supportUserStatus.UNLOCK }));
  }, [dispatch]);

  const handleNavigationActiveDashboardUsers = useCallback(
    (cursorId: string) => {
      dispatch(getSupportUsers({ status: 'UNLOCK', cursor: cursorId }));
    },
    [dispatch],
  );

  return {
    activeDashboardUsers,
    activeDashboardUsersCursor,
    isActiveDashboardUsersLoading,
    handleNavigationActiveDashboardUsers,
  };
}
